import { useState, useEffect, useRef } from 'react'
import { useLanguage } from '../context/LanguageContext'

const COUNTER_CONFIGS = [
  { key: 'impact', prefix: '$', from: 0, to: 100, suffix: 'M' },
  { key: 'sold', prefix: '$', from: 350, to: 400, suffix: 'M' },
  { key: 'lifetime', prefix: '$', from: 0, to: 200, suffix: 'M' },
  { key: 'current', prefix: '$', from: 0, to: 100, suffix: 'M' },
]

function Counter({ title, prefix, from, to, suffix, isFirst }) {
  const [value, setValue] = useState(from)
  const ref = useRef(null)
  const observed = useRef(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !observed.current) {
        observed.current = true
        const duration = 2000
        const steps = 60
        const increment = (to - from) / steps
        let current = from
        const timer = setInterval(() => {
          current += increment
          if (current >= to) { current = to; clearInterval(timer) }
          setValue(Math.round(current))
        }, duration / steps)
      }
    }, { threshold: 0.4 })
    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [from, to])

  return (
    <div ref={ref} style={{
      flex: '1 1 0',
      // No left border on the first item, divider on the rest
      borderLeft: isFirst ? 'none' : '0.5px solid rgba(255,255,255,0.18)',
      padding: '15px 0 15px 30px',
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Number above, label below — matching HTML's column-reverse counter layout */}
      <div style={{
        color: '#ffffff',
        fontFamily: "'Poppins', sans-serif",
        fontSize: '35px',
        fontWeight: 500,
        lineHeight: '1.6em',
        letterSpacing: '3.1px',
      }}>
        {prefix}{value}{suffix}
      </div>
      <div style={{
        color: '#ffffff',
        fontFamily: "'Poppins', sans-serif",
        fontSize: '13px',
        fontWeight: 400,
        textTransform: 'uppercase',
        letterSpacing: '0.6px',
        marginTop: '2px',
      }}>
        {title}
      </div>
    </div>
  )
}

function StatsSection() {
  const { t } = useLanguage()
  const counters = COUNTER_CONFIGS.map(c => ({ ...c, title: t(`stats.${c.key}`) }))
  return (
    <div style={{ backgroundColor: '#FFFFFF', width: '100%', boxSizing: 'border-box' }}>
      <style>{`
        .stats-inner-flex {
          max-width: 1300px;
          margin: 0 auto;
          padding: 0 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 0;
          box-sizing: border-box;
          flex-wrap: wrap;
        }
        .stats-counter-item {
          flex: 1 1 180px;
        }
        @media (max-width: 768px) {
          .stats-inner-flex { padding: 0 24px; }
          .stats-counter-item { flex: 1 1 calc(50% - 24px); }
        }
        @media (max-width: 420px) {
          .stats-inner-flex { padding: 0 16px; }
          .stats-counter-item { flex: 1 1 100%; border-left: none !important; padding-left: 0 !important; }
        }
      `}</style>
      <div style={{
        width: 'calc(100% - 40px)',
        margin: '0 auto',
        backgroundColor: '#002E53',
        borderRadius: '10px',
        border: '1px solid rgba(200, 218, 235, 0.22)',
        padding: '40px 0',
        boxSizing: 'border-box',
      }}>
        <div className="stats-inner-flex">
          {counters.map((c, i) => (
            <div key={i} className="stats-counter-item">
              <Counter {...c} isFirst={i === 0} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default StatsSection
